import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {IBaseResourcePath} from '@toolify/server/src/services/ResourceService/types/resourcePath/IBaseResourcePath'

// One definition of "does this notification belong to this scope" (global scope matches every
// notification) — shared so every badge/list listener reacts to the same set of events
export function doesNotificationResourcePathMatchScope(
  resourcePath: IBaseResourcePath | null | undefined,
  scopeResourceType?: ResourceType | null,
  scopeResourceId?: string | null,
): boolean {
  if(!scopeResourceType || !scopeResourceId) {
    return true
  }
  return !!resourcePath?.some(resourcePathItem => {
    return resourcePathItem.resourceId === scopeResourceId
      && resourcePathItem.resourceType === scopeResourceType
  })
}
